// Returns the base URL for API calls.
// In production (deployed domain), uses relative URLs so it works on any domain.
// In preview, uses the REACT_APP_BACKEND_URL env variable.
function getApiUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl && window.location.origin === envUrl) return envUrl;
  // On deployed domain: use origin so /api/* routes work
  return window.location.origin;
}

export const API_URL = getApiUrl();
